<script>
  import { getContext } from "svelte";

  import Image from "$lib/components/Image.svelte";
  import Bleed from "./Bleed.svelte";
  import { altTextToDisplay } from "$lib/utilities";

  export let quoteContent;
  export let quoteCaption = "";
  export let quoteImage = null;

  //This remains a configurable variable for Storybook purposes.
  export let fullWidth = !getContext("containerized");

  /** @type { "right" | "left "}*/
  export let imagePosition = "right";

  const BIG_QUOTE_CHAR_LIMIT = 150;

  let clazz = "";
  export { clazz as class };

  const imageLeft = imagePosition === "left";

  const paddingClasses = `${
    quoteImage
      ? imageLeft
        ? `${fullWidth ? "pl-24 md:pr-72 lg:pr-0" : ""} md:pl-0`
        : `${fullWidth ? "pl-24 md:pl-72 lg:pl-0" : ""} md:pr-0`
      : fullWidth
        ? "px-24 md:px-72"
        : ""
  }`;

  const imageOffsetClasses = imageLeft
    ? "md:left-[-5%] lg:left-0 lg:pr-[5%]"
    : "md:left-[5%] lg:left-0 lg:pl-[5%]";

  const imageClipClasses = imageLeft
    ? `clip-right md:clip-left ${fullWidth ? "lg:clip-none" : ""}`
    : `clip-right ${fullWidth ? "lg:clip-none" : ""}`;

  const quoteSizeClasses = quoteImage
    ? `md:w-2/3 ${fullWidth ? (imageLeft ? "lg:pr-24" : "lg:pl-24") : ""}`
    : "w-full";

  const desktopFontSize = quoteContent.length > BIG_QUOTE_CHAR_LIMIT ? "" : "md:text-size-48";

  export const quoteImageAltText = altTextToDisplay(quoteImage?.fields.altText);
</script>

<Bleed {fullWidth} contentClasses={paddingClasses}>
  <div class=" flex flex-col justify-center md:flex-row relative w-full overflow-x-clip {clazz}">
    <figure class="my-auto {quoteSizeClasses}" class:md:order-2={imageLeft}>
      <blockquote
        class="text-size-32 {desktopFontSize} font-heading font-bold"
        class:text-center={!quoteImage}
      >
        “{quoteContent}”
      </blockquote>
      <figcaption
        class="pt-24 lg:pt-48 text-neutral-600 w-full font-bold"
        class:text-center={!quoteImage}
        class:md:text-right={!!quoteImage}
        class:pr-48={quoteImage}
      >
        <!--This guard exists because there are some old entries that do not have quote captions. These existed before
      the migration that made the field required.-->
        {#if quoteCaption?.length > 0}
          <cite>- {quoteCaption}</cite>
        {/if}
      </figcaption>
    </figure>
    {#if quoteImage}
      <div
        class="top-0 pt-24 md:pt-0 md:m-auto mr-[-5%] md:w-1/3 relative left-[15%] {imageOffsetClasses}"
      >
        <Image
          containerElement={"div"}
          elementClass="rounded-full w-full object-cover aspect-square {imageClipClasses}"
          asset={quoteImage.fields.imageAsset}
          alt={quoteImage.fields.altText}
        />
      </div>
    {/if}
  </div>
</Bleed>
